import { useGetBasicUomEnum } from 'hooks';

import { getUomTypesAbbreviations } from '../constants';
import LinearVitaminLabel from 'pages/product-full-view/components/product-media-area/nutrition-label/components/LinearVitaminLabel';
import { HighlightTextLinear } from '../WrapperNutrient';
import { parseNumber } from 'utils/parser';

const highlightLabelName = [
  'FAT',
  'CHOLESTEROL',
  'NA',
  'CHOLESTEROL',
  'CARBOHYDRATES',
  'PROTEIN',
  'FD',
];

function LinearLabel({ property, nutrients, snapshotValue }) {
  const { basicUomProperties } = useGetBasicUomEnum();

  const checkHighlightName = (typeCode) =>
    highlightLabelName.includes(typeCode);

  const getNutrientBasisQtyTypeCode = (label) => {
    if (label?.nutrientBasisQuantityTypeCode === 'By Child Nutrition serving') {
      return 'Child Nutrition serving';
    }
    if (label?.nutrientBasisQuantityTypeCode === 'By Package or Container') {
      return 'Container';
    }
    if (label?.nutrientBasisQuantityTypeCode === 'By Measure') {
      return 'Measure';
    }

    return 'Serving';
  };

  return (
    <div className='nutrition-facts__label--linear'>
      <span className='nutrition-facts__label--linear-label'>
        Nutrition Facts
      </span>
      {property?.servingsPerContainer ? (
        <HighlightTextLinear
          label={['servingsPerContainer']}
          currentValue={property}
          snapshotValue={snapshotValue}
        >
          <span>Servings: {property?.servingsPerContainer},</span>
        </HighlightTextLinear>
      ) : (
        <span>,</span>
      )}
      <HighlightTextLinear
        label={[
          'servingSizeDescription',
          'servingSize',
          'servingSizeMeasurement',
        ]}
        currentValue={property}
        snapshotValue={snapshotValue}
      >
        <span className='nutrition-facts__label--linear__servingsize-bold'>
          Serv. Size:{' '}
        </span>
        <span className='nutrition-facts__label--linear__servingsize-bold nutrition-facts__servingsize-word-break'>
          {property?.servingSizeDescription}{' '}
          {property?.servingSize &&
            `(${property?.servingSize} ${getUomTypesAbbreviations(
              basicUomProperties,
              property?.servingSizeMeasurement,
            )}),`}
        </span>
      </HighlightTextLinear>
      <HighlightTextLinear
        label={['calories']}
        currentValue={property}
        snapshotValue={snapshotValue}
      >
        <span>Amount Per {getNutrientBasisQtyTypeCode(property)}:</span>
        <span className='nutrition-facts__label--linear__servingsize-bold'>
          {`Calories ${property?.calories ? property?.calories : 0},`}
        </span>
      </HighlightTextLinear>
      <>
        {nutrients?.map((nutrient, idx) => {
          return (
            <LinearVitaminLabel
              key={idx}
              label={nutrient?.nutritionName}
              labelBold={checkHighlightName(nutrient?.nutritionTypeCode)}
              ingredient={nutrient}
              gram={`${parseNumber(
                nutrient?.quantity,
              )}${getUomTypesAbbreviations(
                basicUomProperties,
                nutrient?.quantityUom,
              )}`}
              percent={nutrient.dailyValueIntakePercent}
            />
          );
        })}
      </>
    </div>
  );
}

export default LinearLabel;
